import api_key from "./env.js";

export const authEndpoint = "https://accounts.spotify.com/authorize";
const redirectUri = window.location.origin + "/";
const client_id = api_key;

const scopes = [
  "user-read-currently-playing",
  "user-read-recently-played",
  "user-read-playback-state",
  "user-read-playback-position",
  "user-top-read",
  "user-modify-playback-state",
  "app-remote-control",
  "user-modify-playback-state",
  "streaming",
  "user-library-read",
];

export const getTokenFromLogin = () => {
  return window.location.hash
    .substring(1)
    .split("&")
    .reduce((initial, item) => {
      var parts = item.split("=");
      initial[parts[0]] = decodeURIComponent(parts[1]);
      return initial;
    }, {});
};

export const loginUrl = `${authEndpoint}?client_id=${client_id}&redirect_uri=${redirectUri}&scope=${scopes.join(
  "%20"
)}&response_type=token&show_dialog=true`;
